import axios from "axios";
const instance = axios.create({
  baseURL: "https://mahapravhu-furniture.vercel.app",
  // baseURL: "http://localhost:5000",
});

export default instance;